import HandIcon from '@nv/images/design/hand-icon.jsx'
import { useTranslation } from 'react-i18next'
import styles from './UsernameBanner.module.scss'

export const UsernameBanner = () => {
  const { t } = useTranslation()

  return (
    <div className={styles['container']}>
      <HandIcon className={styles['hand-icon']} />
      <span className={styles['text']}>{t('auth.authMethod.username-banner')}</span>
    </div>
  )
}
